export var EOgqlJobState;

(function (EOgqlJobState) {
  EOgqlJobState["created"] = "created";
  EOgqlJobState["enqueued"] = "enqueued";
  EOgqlJobState["finished"] = "finished";
  EOgqlJobState["failed"] = "failed";
  EOgqlJobState["cancelled"] = "cancelled"; // Cancelled is not currently supported by the OGQL v0 API itself but, the query effects will return this
  // value when the query is cancelled.
})(EOgqlJobState || (EOgqlJobState = {}));